var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyRo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75C14.2583 18.75 13.5333 18.5301 12.9166 18.118C12.2999 17.706 11.8193 17.1203 11.5355 16.4351C11.2516 15.7498 11.1774 14.9958 11.3221 14.2684C11.4668 13.541 11.8239 12.8728 12.3484 12.3484C12.8728 11.8239 13.541 11.4668 14.2684 11.3221C14.9958 11.1774 15.7498 11.2516 16.4351 11.5355C17.1203 11.8193 17.706 12.2999 18.118 12.9166C18.5301 13.5333 18.75 14.2583 18.75 15C18.7489 15.9942 18.3534 16.9474 17.6504 17.6504C16.9474 18.3534 15.9942 18.7489 15 18.75ZM15 12.5C14.5055 12.5 14.0222 12.6466 13.6111 12.9213C13.2 13.196 12.8795 13.5865 12.6903 14.0433C12.5011 14.5001 12.4516 15.0028 12.548 15.4877C12.6445 15.9727 12.8826 16.4181 13.2322 16.7678C13.5819 17.1174 14.0273 17.3555 14.5123 17.452C14.9972 17.5484 15.4999 17.4989 15.9567 17.3097C16.4135 17.1205 16.804 16.8 17.0787 16.3889C17.3534 15.9778 17.5 15.4945 17.5 15C17.4993 14.3372 17.2356 13.7017 16.7669 13.2331C16.2983 12.7644 15.6628 12.5007 15 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75H5V15H10V13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10H5V11.25H11.25V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5002H3.75V2.50021H8.75V6.25021C8.75096 6.58144 8.88296 6.89883 9.11717 7.13304C9.35139 7.36725 9.66877 7.49926 10 7.50021H13.75V9.37521H15V6.25021C15.0022 6.16807 14.9866 6.08642 14.9543 6.01089C14.9219 5.93536 14.8735 5.86774 14.8125 5.81271L10.4375 1.43771C10.3825 1.37667 10.3149 1.32829 10.2393 1.29592C10.1638 1.26355 10.0821 1.24795 10 1.25021H3.75C3.41877 1.25117 3.10139 1.38317 2.86717 1.61739C2.63296 1.8516 2.50096 2.16899 2.5 2.50021V17.5002C2.50096 17.8314 2.63296 18.1488 2.86717 18.383C3.10139 18.6173 3.41877 18.7493 3.75 18.7502H10V17.5002ZM10 2.75021L13.5 6.25021H10V2.75021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyRo);
export default __webpack_public_path__ + "static/media/verify-ro.1d5eb65185afab7502f52c29b6a46f4f.svg";
export { ForwardRef as ReactComponent };